import { useMemo, useState, type ReactNode } from 'react';

import {
  DetailOverlayContext,
  EMPTY_SLOTS,
  type DetailOverlayContextValue,
  type DetailOverlaySlots,
} from './detailOverlay.types';

interface DetailOverlayProviderProps {
  children: ReactNode;
}

/**
 * Hosts the active content component's slots plus the unified fullscreen
 * flag. The SlidePanel shell reads both; content components publish slots
 * via `useRegisterDetailSlots` and read fullscreen via
 * `useDetailOverlayFullscreen`.
 */
export function DetailOverlayProvider({
  children,
}: DetailOverlayProviderProps) {
  const [slots, setSlots] = useState<DetailOverlaySlots>(EMPTY_SLOTS);
  const [isFullscreenMode, setIsFullscreenMode] = useState(false);

  const contextValue = useMemo<DetailOverlayContextValue>(
    () => ({ slots, setSlots, isFullscreenMode, setIsFullscreenMode }),
    [slots, isFullscreenMode]
  );

  return (
    <DetailOverlayContext.Provider value={contextValue}>
      {children}
    </DetailOverlayContext.Provider>
  );
}
